// src/pages/BlogPost.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../lib/firebase";
import { doc, getDoc } from "firebase/firestore";
import ReactMarkdown from "react-markdown";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);

  useEffect(() => {
    (async () => {
      const snap = await getDoc(doc(db, "posts", slug));
      if (snap.exists()) setPost(snap.data());
    })();
  }, [slug]);

  if (!post) {
    return (
      <div style={{ color: "#e9eef5", margin: "90px auto", maxWidth: 960, padding: "0 18px" }}>
        Loading…
      </div>
    );
  }

  // Remove a leading H1 from markdown so the title doesn't duplicate
  const cleanedMarkdown = (post.content || "").replace(/^\s*#\s+.*\n+/, "");

  const dateStr = post.publishedAt?.toDate?.().toDateString?.() || "";

  return (
    <div style={{ maxWidth: 960, margin: "90px auto", padding: "0 18px", color: "#e9eef5" }}>
      {/* Back button */}
      <button
        onClick={() => navigate("/blog")}
        style={{
          background: "transparent",
          color: "#FFD700",
          border: "1.5px solid #FFD700",
          padding: "8px 14px",
          borderRadius: 999,
          fontWeight: 800,
          cursor: "pointer",
          marginBottom: 14
        }}
      >
        ← Back to Blog
      </button>

      {/* Title (only once) */}
      <h1 style={{ color: "#ffd13b", margin: "6px 0 4px" }}>{post.title}</h1>
      {dateStr && <div style={{ opacity: 0.8, marginBottom: 12 }}>{dateStr}</div>}

      {/* Cover image (optional) */}
      {post.coverUrl && (
        <img
          src={post.coverUrl}
          alt=""
          style={{ width: "100%", borderRadius: 12, margin: "12px 0 18px" }}
        />
      )}

      {/* Markdown content (with leading H1 stripped) */}
      <div
        style={{
          background: "rgba(14,18,24,.72)",
          border: "1px solid rgba(255,209,59,.25)",
          borderRadius: 16,
          padding: 18
        }}
      >
        <ReactMarkdown>{cleanedMarkdown}</ReactMarkdown>
      </div>
    </div>
  );
}
